import { ReloadOutlined } from "@ant-design/icons";
import React from "react";
import {Button, Card, CardBody, Col, Container, Row} from "reactstrap";

const OfflinePage = () => {
    document.title = "Hors Ligne | PAXITY - Votre agrégateur de paiement";
    return (
        <React.Fragment>
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>
                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col xl={5}>
                                <Card className="overflow-hidden">
                                    <CardBody className="p-4">
                                        <div className="text-center">
                                            <img src={"offline.gif"} alt="" height="210" />
                                            <h3 className="mt-4 fw-semibold">Vous etes actuellement en hors ligne</h3>
                                            <p className="text-muted mb-4 fs-14">Nous ne pouvons pas vous montrer cette page car vous n'êtes pas connecté à Internet. Lorsque vous êtes de retour en ligne, actualisez la page ou cliquez sur le bouton ci-dessous</p>
                                            <Button 
                                                color="success" 
                                                className="btn-border"
                                                onClick={() => "window.location.href=window.location.href"}
                                            >
                                                <i className="ri-refresh-line align-bottom"></i> Actualiser <ReloadOutlined />
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </React.Fragment>
    );
};

export default OfflinePage;